export const INTERACTION_TYPE_ANIMATION = "obrazky";
export const INTERACTION_TYPE_GIFT = "darecky";
export const INTERACTION_TYPE_SIGNPOST = "rozcestnik";
export const INTERACTION_TYPE_DOWNLOAD = "stahnout_hru";
export const INTERACTION_TYPE_SOUND = "nastaveni";

const EVENT_GAME_INTERACTION = "game_interaction";
const EVENT_GAME_START = "game_play";

declare global {
  interface Window {
    DP: any;
  }
}

export const sendInteractionEvent = (
  type: string,
  title: string | number,
  isInteraction: boolean = true
) => {
  if (window.DP) {
    window.DP.ifAnalytics((dpAnalytics: any) => {
      dpAnalytics.trackEvent(
        new window.DP.analytics.EventBuilder()
          .setEventName(EVENT_GAME_INTERACTION)
          .setGame("45d082bb-a27f-41e2-8363-23c0f69da12a", "Advent2024")
          .setGameContent(title, type)
          .setInteraction(isInteraction)
      );
    });
  }
};

export const sendStartEvent = () => {
  if (window.DP) {
    window.DP.ifAnalytics((dpAnalytics: any) => {
      dpAnalytics.trackEvent(
        new window.DP.analytics.EventBuilder()
          .setEventName(EVENT_GAME_START)
          .setGame("45d082bb-a27f-41e2-8363-23c0f69da12a", "Advent2024")
          .setInteraction(true)
      );
    });
  }
};
